import { Card } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import { DashboardContext } from "../contexts/DashboardContextProvider";
import { format } from "date-fns";
import LineChart from "../../../components/Charts/LineChart";
import { enumerateDaysBetweenDates } from "../../../utils/helper";

const lineGraph = {
  labels: [],
  data: [],
};
const GraphAnalytics = ({ dateRange, propertyId }) => {
  const { visitorCountData, pageViewsData, chatCountData } =
    useContext(DashboardContext);

  const [lineGraphConfig, setLineGraphConfig] = useState(lineGraph);

  useEffect(() => {
    const dates = enumerateDaysBetweenDates(
      dateRange[0],
      dateRange[1],
      "DD MMM"
    );
    const visitorGroup = groupBy(visitorCountData, "createdAt", "visitorCount");
    const chatGroup = groupBy(chatCountData, "createdAt", "chatCount");
    const pageViewsGroup = groupBy(pageViewsData, "createdAt", "pageViews");
    const visitorData = [];
    const chatData = [];
    const pageViewData = [];
    for (const date of dates) {
      visitorData.push(
        visitorGroup[date]?.reduce((prev, curr) => prev + curr, 0) || 0
      );
      chatData.push(
        chatGroup[date]?.reduce((prev, curr) => prev + curr, 0) || 0
      );
      pageViewData.push(
        pageViewsGroup[date]?.reduce((prev, curr) => prev + curr, 0) || 0
      );
    }

    setLineGraphConfig({
      labels: dates,
      data: [
        {
          fill: false,
          tension: 0.1,
          label: "Visitors",
          backgroundColor: "#3619f0",
          data: visitorData,
          options: {
            legend: false,
          },
        },
        {
          fill: false,
          tension: 0.1,
          label: "Chats",
          backgroundColor: "#4DA74D",
          data: chatData,
        },
        {
          fill: false,
          tension: 0.1,
          label: "Page Views",
          backgroundColor: "#F7941D",
          data: pageViewData,
        },
      ],
    });
  }, [visitorCountData, pageViewsData, chatCountData]);

  const groupBy = (array, key, addKey) => {
    return array.reduce((result, currentValue) => {
      (result[format(currentValue[key].toDate(), "dd MMM")] =
        result[format(currentValue[key].toDate(), "dd MMM")] || []).push(
        currentValue[addKey]
      );
      return result;
    }, {});
  };

  return (
    <Card className="graph_card">
      <h2 className="card_title">Successfull Engagements</h2>

      <LineChart labels={lineGraphConfig.labels} data={lineGraphConfig.data} />
    </Card>
  );
};

export default React.memo(GraphAnalytics);
